import { render, staticRenderFns } from "./dynamic-form.vue?vue&type=template&id=b279b012"
import script from "./dynamic-form.vue?vue&type=script&lang=js"
export * from "./dynamic-form.vue?vue&type=script&lang=js"
import style0 from "./dynamic-form.vue?vue&type=style&index=0&id=b279b012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports